<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div v-if="promotion">
      <div class="row">
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Nombre de la promoción</div>
          <div> {{ promotion.name }} </div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">id de promoción</div>
          <div> {{ promotion.promotionId }} </div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Descripción</div>
          <div> {{ promotion.description }} </div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Estado</div>
          <span v-if="promotion.status === 'ACTIVATED'"
              class="badge text-success border border-success">{{ getTitle(promotion.status) }}</span>
          <span v-else-if="promotion.status === 'PENDING'"
              class="badge text-info border border-info">{{ getTitle(promotion.status) }}</span>
          <span v-else-if="promotion.status === 'DEACTIVATED' || promotion.status === 'DELETED'"
              class="badge text-danger border border-danger">{{ getTitle(promotion.status) }}</span>
          <span v-else class="badge text border">{{ getTitle(promotion.status) }}</span>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de inicio</div>
          <div> {{ $dateBackToFront(promotion.start_date)}} </div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de fin</div>
          <div> {{ $dateBackToFront(promotion.end_date) }} </div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Tenant</div>
          <div v-if="promotion.tenant && promotion.tenant.length > 0"> 
            <template v-for="(tenant, index) in promotion.tenant">
              {{ tenant.toUpperCase() }}{{ index === (promotion.tenant.length - 1) ? '' : ', ' }}
            </template>
          </div>
          <div v-else>-</div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Canal</div>
          <div v-if="promotion.channel && promotion.channel.length > 0"> 
            <template v-for="(channel, index) in promotion.channel">
              {{ channel.toUpperCase() }}{{ index === (promotion.channel.length - 1) ? '' : ', ' }}
            </template>
          </div>
          <div v-else>-</div>
        </div>
        <div class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Limite de unidades</div>
          <div> {{ promotion.units_limit }} </div>
        </div>
        <div class="col-12 col-lg-9 mb-3 mt-1">
          <div class="generalTitleItemModal">Clientes</div>
          <div v-if="promotion.customers && promotion.customers.legal_identifier && promotion.customers.legal_identifier.length > 0"> 
            <template v-for="(customer, index) in promotion.customers.legal_identifier">
              {{ customer.toUpperCase() }}{{ index === (promotion.customers.legal_identifier.length - 1) ? '' : ', ' }}
            </template>
          </div>
          <div v-else>-</div>
        </div>
        <div v-if="promotion.vouchers.voucher_code != ''" class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Cupón</div>
          <div> {{ promotion.vouchers.voucher_code }} </div>
        </div>
        <div v-if="promotion.vouchers.use_limit != ''" class="col-6 col-lg-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Límite Cupón</div>
          <div> {{ promotion.vouchers.use_limit }} </div>
        </div>
        <div v-if="promotion.feeDiscounts && promotion.feeDiscounts.length > 0" class="col-12 mb-3 mt-1">
          <div class="row">
            <div class="col-3 col-lg-2 mb-3 mt-1" v-for="(quote, i) in promotion.feeDiscounts" :key="i">
              <div class="generalTitleItemModal">Cuota {{ i+1 }}</div>
              <div>{{quote.value}}{{ quote.discountType == "PERCENTAGE" ? '%' : "€" }}</div>
            </div>
          </div>
        </div>
        <div v-if="promotion.criteria.name !== '' && promotion.criteria.condition !== ''" class="col-12 mb-3 mt-1" style="border: 1px solid #dee2e6;">
          <div style="font-size: 20px; font-weight: bold;">Criterio</div>
          <div class="row">
            <div class="col-12 col-lg-4 mb-3 mt-1">
              <div class="generalTitleItemModal">Nombre</div>
              <div>{{promotion.criteria.name || "-"}}</div>
            </div>
            <div class="col-12 col-lg-8 mb-3 mt-1">
              <div class="generalTitleItemModal">Condición</div>
              <div>{{promotion.criteria.condition || "-"}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";

export default {
  name: "PromotionDetail",
  props: [
    "id",
    "modalTitle",
    "class",
    "promotion",
  ],
  data() {
    return {
      classes: this.class,
    };
  },
  components: {
    Modal,
  },
  methods: {
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
    getTitle(title) {
      switch (title) {
        case 'ACTIVATED':
          return 'ACTIVO';
        case 'PENDING':
          return 'PENDIENTE';
        case 'DEACTIVATED':
          return 'DESACTIVADO';
        case 'DELETED':
          return 'ELIMINADO';
        default:
          return title;
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
